(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Signup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_login_new_account__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93910);
/* harmony import */ var _components_fields_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15808);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64074);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(styles_misc_module_css__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5079);
/* harmony import */ var styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6350);
/* harmony import */ var _components_IsLoggedOutWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75877);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86501);
/* harmony import */ var _components_ErrorTag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48367);
/* harmony import */ var _services_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47329);
/* harmony import */ var _components_Footer_CryptoFooter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14389);
/* harmony import */ var _components_Toast__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49864);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_14__);








// import { } from "next-auth/react"












function Signup() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_6__/* .StoreContext */ .x);
    var authAction = context.actions.auth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), pageError = ref1[0], setPageError = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var SignInPrompt = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().promptContainer),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().prompt),
                children: [
                    "Already have an account?",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/login",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().promptLink),
                            children: "Sign in"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_IsLoggedOutWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "CryptoSports | Sign up"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_14___default()), {
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat("G-YVMJQBW8BG")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_14___default()), {
                        id: "google-analytics",
                        children: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '".concat("G-YVMJQBW8BG", "');\n          ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().loginContent),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().titleGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/cslogo.svg",
                                    alt: "CryptoSports",
                                    className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().logoSvg)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_17___default().tagline)),
                                    children: "Collect. Play. Win."
                                })
                            ]
                        }),
                        !visible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().banner),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().bar), (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().left))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/Justin-Jefferson.png",
                                    alt: "kevin card",
                                    className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().card)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().bar), (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().right))
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_login_new_account__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    onSubmit: function() {
                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(fields) {
                                            var ref, signUpAccountResult, error;
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        setPageError(null);
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            (0,_services_auth__WEBPACK_IMPORTED_MODULE_10__/* .signUpAccount */ .VQ)(fields)
                                                        ];
                                                    case 2:
                                                        signUpAccountResult = _state.sent();
                                                        if ((ref = signUpAccountResult.data) === null || ref === void 0 ? void 0 : ref.success) {
                                                            authAction.setEmail(fields.email);
                                                            authAction.setPassword(fields.password);
                                                            authAction.setNewSignup(true);
                                                            router.push("/signup/confirm/".concat(fields.email));
                                                        } else if (signUpAccountResult.data.error || signUpAccountResult.data.message) {
                                                            react_hot_toast__WEBPACK_IMPORTED_MODULE_8__/* ["default"].error */ .ZP.error(function() {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Toast__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                    message: signUpAccountResult.data.error || signUpAccountResult.data.message
                                                                });
                                                            });
                                                            setPageError(function() {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Toast__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                    message: signUpAccountResult.data.error || signUpAccountResult.data.message
                                                                });
                                                            });
                                                        }
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        error = _state.sent();
                                                        console.log(error);
                                                        react_hot_toast__WEBPACK_IMPORTED_MODULE_8__/* ["default"].error */ .ZP.error(function() {
                                                            var ref, ref1;
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Toast__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                message: ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || error.error_message || "Unexpected Error"
                                                            });
                                                        });
                                                        setPageError(function() {
                                                            var ref, ref1;
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Toast__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                message: ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || error.error_message || "Unexpected Error"
                                                            });
                                                        });
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(fields) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().centerError),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorTag__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        message: pageError
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignInPrompt, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().buttonGroup),
                            children: !visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fields_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                text: "Sign up with Email",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().signupButton), (styles_signup_signup_module_css__WEBPACK_IMPORTED_MODULE_15___default().emailSignupButton)),
                                onClick: function() {
                                    // signUp();
                                    setVisible(true);
                                }
                            })
                        }),
                        !visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignInPrompt, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer_CryptoFooter__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,3662,1664,9284,8343,1524,4231,2580,8491,4786,2675,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);